export const COLLABORATOR_INVITATION_PATH = '/invitacion-colaborador'
export const isCollaboratorInvitationState = (name) => name === 'collaboratorInvitation'

// Same URL parameter name used by password-recovery email links.
const CODE_PARAMETER = 'k'

// Presence only. An opaque invitation code is NOT authentication or authorization.
// TODO(backend): resolve its validity, expiry, recipient and assigned access server-side.
export function readCollaboratorInvitationLink(href = window.location.href) {
  const url = new URL(href)
  if (url.pathname.replace(/\/$/, '') !== COLLABORATOR_INVITATION_PATH) return { status: 'missing', code: null }

  const fragment = new URLSearchParams(url.hash.slice(1))
  const values = [url.searchParams, fragment].flatMap((params) =>
    params.getAll(CODE_PARAMETER).map((value) => value.trim()),
  )
  if (!values.length) return { status: 'missing', code: null }
  if (values.some((value) => !value) || new Set(values).size !== 1) return { status: 'invalid', code: null }
  return { status: 'present', code: values[0] }
}
